import { Trans, useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger
} from '@/components/Dialog';
import VisuallyHidden from '@/components/VisuallyHidden';
import Error from '@/icons/error.svg';
import NoVatIcon from '@/icons/no-vat.svg';
import { cn } from '@/utils';

function NoVatModal({ open, onOpenChange }) {
	const { t } = useTranslation();
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogTrigger asChild>
				<Button
					className="w-full justify-end gap-2 text-sm font-normal leading-6 text-orange"
					variant="outline-white"
					size="iconSm"
				>
					<Error /> <span>{t('checkout.noVAT.CTA')}</span>
				</Button>
			</DialogTrigger>

			<DialogContent className="w-[320px] p-0 md:w-[397px]">
				<DialogHeader className="flex h-12 flex-row items-center justify-between border-b border-grey-200 px-4">
					<DialogTitle
						className={cn(
							'font-title text-xs font-semibold leading-5 md:text-sm md:leading-6',
							'text-sm leading-6'
						)}
					>
						{t('checkout.noVAT.title')}
					</DialogTitle>
					<VisuallyHidden asChild>
						<DialogDescription>
							{t('checkout.noVAT.description')}
						</DialogDescription>
					</VisuallyHidden>
				</DialogHeader>

				<div className="flex flex-col gap-2 px-6 py-9 text-sm font-normal leading-6 text-grey-500">
					<div className="flex justify-center">
						<NoVatIcon />
					</div>
					<Trans
						t={t}
						i18nKey="checkout.noVAT.text"
						components={{
							strong: <strong className="font-semibold" />
						}}
					/>
				</div>
				<DialogFooter mobileSingleColumn>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						{t('common.cancel')}
					</Button>
					<Button onClick={() => onOpenChange(false)}>
						{t('common.accept')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default NoVatModal;
